/* global theme */

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const geoIp = theme.geoIp;
        const regionCode = theme.geoIpRegion || 'US';
        const cookieCountryCode = getCookie('country_code');
        /**
         * @type {((callback: (response?: { country_code2?: string }) => void, apiKey: string) => void) | undefined}
         */
        const requestGeolocation =
            typeof window !== 'undefined' && typeof /** @type {any} */ (window).getGeolocation === 'function'
                ? /** @type {(callback: (response?: { country_code2?: string }) => void, apiKey: string) => void} */ (
                      /** @type {any} */ (window).getGeolocation
                  )
                : undefined;

        /**
         * @param {string} selector
         * @param {(element: Element) => void} callback
         */
        const toggleNodes = (selector, callback) => {
            document.querySelectorAll(selector).forEach((element) => {
                callback(element);
            });
        };

        /**
         * @param {string} selector
         */
        const showNodes = (selector) => {
            toggleNodes(selector, (el) => {
                if (el instanceof HTMLElement) {
                    if(el.classList.contains('product-information')) {
                        el.style.display = 'grid';
                    } else if (el.classList.contains('predictive-search-results__card')) {
                        el.style.display = 'list-item';
                    } else {
                        el.style.display = 'flex';
                    }
                    el.style.visibility = 'visible';
                }
            });
        };

        /**
         * @param {string} selector
         */
        const hideNodes = (selector) => {
            toggleNodes(selector, (el) => {
                if (el instanceof HTMLElement) {
                    el.style.display = 'none';
                }
            });
        };

        /**
         * @param {string} selector
         */
        const removeNodes = (selector) => {
            toggleNodes(selector, (el) => {
                if ('remove' in el) {
                    el.remove();
                }
            });
        };

        const hasListContext = () =>
            Boolean(document.querySelector('.collection, .search, .cart-drawer, [data-visible-limit]'));

        /**
         * @param {string} selector
         * @param {boolean} shouldApply
         */
        const applyListStyles = (selector, shouldApply) => {
            if (!shouldApply) {
                return;
            }

            setStyle(selector);
        };

        const updateNoUsContent = () => {
            toggleNodes('[data-no-us]', (el) => {
                if (!(el instanceof HTMLElement)) {
                    return;
                }

                const content = el.getAttribute('data-no-us');
                if (content) {
                    el.innerHTML = content;
                }
            });

            const noUsLink = document.querySelector('[data-no-us-link]');
            if (noUsLink) {
                const href = noUsLink.getAttribute('data-no-us-link');
                if (href) {
                    noUsLink.setAttribute('href', href);
                }
            }
        };

        /**
         * @param {{ country_code2?: string } | undefined} response
         */
        function handleResponse(response) {
            const locationCountryCode = response && response.country_code2 ? response.country_code2 : regionCode;
            setCookie('country_code', locationCountryCode, 1, 0);
            prepareContent(locationCountryCode);
        }

        /**
         * @param {string} location
         */
        function prepareContent(location) {
            let resolvedLocation = location;

            if (resolvedLocation !== 'US') {
                const locale = getQueryVariable('locale');
                if (locale && locale.toLowerCase() === 'en-us') {
                    resolvedLocation = 'US';
                }
            }

            const listContext = hasListContext();

            if (resolvedLocation !== 'US') {
                checkRedirect('US');

                if (resolvedLocation === 'CA' && regionCode === 'CAN') {
                    removeNodes('.INTL');
                    showNodes('.US');
                    showNodes('.CAN');
                    applyListStyles('.CAN:not(.hidden), .US:not(.hidden)', listContext);
                } else if (resolvedLocation === 'CA' && regionCode === 'US') {
                    hideNodes('.US');
                    showNodes('.CAN');
                    showNodes('.INTL');
                    applyListStyles('.CAN:not(.hidden), .INTL:not(.hidden)', listContext);
                } else {
                    removeNodes('.US');
                    removeNodes('.CAN');
                    showNodes('.INTL');
                    applyListStyles('.INTL:not(.hidden)', listContext);
                }

                updateNoUsContent();
            } else {
                checkRedirect('INTL');
                removeNodes('.INTL');
                hideNodes('.CAN');
                showNodes('.US');
                applyListStyles('.US:not(.hidden)', listContext);
            }

            document.dispatchEvent(new CustomEvent('geoip:country', { detail: { countryCode: resolvedLocation } }));
        }

        if (geoIp === true) {
            prepareContent(regionCode);
        } else if (cookieCountryCode) {
            prepareContent(cookieCountryCode);
        } else {
            const locale = getQueryVariable('locale');
            if (locale) {
                const localeParts = locale.split('-');
                if (localeParts.length > 1) {
                    const localeCountry = localeParts[1];
                    if (localeCountry) {
                        const normalizedCountry = localeCountry.toUpperCase();
                        setCookie('country_code', normalizedCountry, 1, 0);
                        prepareContent(normalizedCountry);

                        return;
                    }
                }
            }

            if (typeof requestGeolocation === 'function') {
                requestGeolocation(handleResponse.bind(this), '777608e6815044638f77282af81528db');
            }
        }

        /**
         * @param {string} name
         * @param {string} value
         * @param {number} days
         * @param {number} hours
         */
        function setCookie(name, value, days, hours) {
            const date = new Date();

            if (days === 0 && hours > 0) {
                date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            } else {
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            }

            const expires = `expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value};${expires};path=/`;
        }

        /**
         * @param {string} name
         * @returns {string}
         */
        function getCookie(name) {
            const match = document.cookie
                .split('; ')
                .find((row) => row.startsWith(`${name}=`));

            return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : '';
        }

        /**
         * @param {string} selector
         */
        function setStyle(selector) {
            const main = document.getElementById('MainContent');
            if (!main) {
                return;
            }

            const style = document.createElement('style');
            const predictiveSelector = selector.split(',').map((part) => `.predictive-search-results__card${part.trim()}`).join(', ');
            style.appendChild(document.createTextNode(`${selector} {display: flex; visibility: visible;}`));
            style.appendChild(document.createTextNode(`${predictiveSelector} {display: list-item;}`));
            main.prepend(style);
        }

        /**
         * @param {string} className
         */
        function checkRedirect(className) {
            const element = document.querySelector('.redirect-check');
            if (!element) {
                return;
            }

            const url = element.getAttribute('data-url') || '/';
            if (element.classList.contains(className)) {
                window.location.href = url;
            }
        }

        /**
         * @param {string} variable
         * @returns {string | false}
         */
        function getQueryVariable(variable) {
            const value = new URLSearchParams(window.location.search).get(variable);
            return value === null ? false : value;
        }
    });
})();
